import { AiSuggestionKind, AiSuggestionWhereInput } from '@/types/schema';

const HOLDING_SUGGESTION_KINDS = [
  AiSuggestionKind.Asset,
  AiSuggestionKind.Liability,
  AiSuggestionKind.LifeInsurance,
];

const ONBOARDING_SUGGESTION_KINDS = [
  AiSuggestionKind.OnboardingEntity,
  AiSuggestionKind.OnboardingTestamentaryEntity,
  AiSuggestionKind.OnboardingIndividual,
  AiSuggestionKind.OnboardingOrganization,
];

export function getEstatePageSuggestionWhere(
  householdId: string,
  {
    detailTargetWhere = {},
    holdingTargetWhere = {},
  }: {
    detailTargetWhere?: AiSuggestionWhereInput;
    holdingTargetWhere?: AiSuggestionWhereInput;
  } = {}
) {
  const pendingWhere = {
    hasHouseholdWith: [{ id: householdId }],
    acceptanceStatusIsNil: true,
    version: 2,
  } satisfies AiSuggestionWhereInput;

  return {
    detailSuggestionsWhere: {
      ...pendingWhere,
      ...detailTargetWhere,
      kindNotIn: [...ONBOARDING_SUGGESTION_KINDS, ...HOLDING_SUGGESTION_KINDS],
    },
    holdingSuggestionsWhere: {
      ...pendingWhere,
      ...holdingTargetWhere,
      kindIn: HOLDING_SUGGESTION_KINDS,
    },
  } satisfies Record<string, AiSuggestionWhereInput>;
}
